import { render, staticRenderFns } from "./NewsTab.vue?vue&type=template&id=57dbdabb&scoped=true"
import script from "./NewsTab.vue?vue&type=script&lang=js"
export * from "./NewsTab.vue?vue&type=script&lang=js"
import style0 from "./NewsTab.vue?vue&type=style&index=0&id=57dbdabb&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dbdabb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57dbdabb')) {
      api.createRecord('57dbdabb', component.options)
    } else {
      api.reload('57dbdabb', component.options)
    }
    module.hot.accept("./NewsTab.vue?vue&type=template&id=57dbdabb&scoped=true", function () {
      api.rerender('57dbdabb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/components/NewsTab.vue"
export default component.exports